export default "__VITE_ASSET__ffbb1fdc__"